import { render, staticRenderFns } from "./nutrients.details.vue?vue&type=template&id=2e4d0d8c&scoped=true&"
import script from "./nutrients.details.vue?vue&type=script&lang=js&"
export * from "./nutrients.details.vue?vue&type=script&lang=js&"
import style0 from "./nutrients.details.vue?vue&type=style&index=0&id=2e4d0d8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4d0d8c",
  null
  
)

export default component.exports